import { ObjectBuilder, ImgButton, Rectangle3D } from "@dreamcam/babylon-tools";
import { Env } from "../../settings/Env";
export class MessengerButton {
    static create(mesh2d) {
        const mb = Env.common.messengerButton;
        const messengerButton = new ImgButton("messengerButton", mb.inactiveImageLayout);
        messengerButton.widthInPixels = mesh2d.m2px(mb.width);
        messengerButton.heightInPixels = mesh2d.m2px(mb.height);
        messengerButton.children[0].detectPointerOnOpaqueOnly = false;
        const unreadMessagesCountContainer = new Rectangle3D("messengerButtonUnreadsBackground");
        unreadMessagesCountContainer.horizontalAlignment = Rectangle3D.HORIZONTAL_ALIGNMENT_RIGHT;
        unreadMessagesCountContainer.verticalAlignment = Rectangle3D.VERTICAL_ALIGNMENT_TOP;
        unreadMessagesCountContainer.adaptWidthToChildren = true;
        unreadMessagesCountContainer.heightInPixels = mesh2d.m2px(mb.unreads.background.height);
        unreadMessagesCountContainer.cornerRadius = mesh2d.m2px(mb.unreads.background.cornerRadius);
        unreadMessagesCountContainer.thickness = 0;
        unreadMessagesCountContainer.useArc = true;
        unreadMessagesCountContainer.background = mb.unreads.background.color;
        messengerButton.addControl(unreadMessagesCountContainer);
        const unreadMessagesCountTextBlock = ObjectBuilder.createTextBlock3D(mesh2d, "messengerButtonUnreadsCountTextBlock", "", mb.unreads.textLayout);
        unreadMessagesCountContainer.addControl(unreadMessagesCountTextBlock);
        unreadMessagesCountContainer.isVisible = false;
        return {
            messengerButton,
            unreadMessagesCountContainer,
            unreadMessagesCountTextBlock,
        };
    }
}
